module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-15-f30c99acb41ead9ef295ae651aa00401.png";